<template>
    <button class="small" :class="{TA:isTestAchat}" @click="$emit('click')">{{ label }}</button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters("subscription", ["isTestAchat"])
    },
    props: {
        label: {
            type: String
        }
    }
}
</script>

<style lang="scss" scoped>
.small {
    padding: 5px 10px;
    font-size: 0.7rem;
    box-shadow: none !important;
    background: $white !important;
    border: 1px solid $yellow;
    line-break: auto;
    max-width: 100%;
    margin-bottom: 15px;
    border-radius: 15px;
    font-weight: bold;

    &:hover {
        cursor: pointer;
        background: $yellow !important;
    }

    &.TA {
      border: 1px solid $pink;

      &:hover {
        background: $pink!important;
        color: $white!important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ActionButton.vue